import { Box, Flex, Link, Text, IconButton } from "@chakra-ui/react";
import { ArrowForwardIcon, CloseIcon } from "@chakra-ui/icons";
import { useState, useEffect } from "react";

const DemoBanner = () => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const bannerState = localStorage.getItem("demoBannerVisible");
    if (bannerState !== null) {
      setIsVisible(JSON.parse(bannerState));
    }
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    localStorage.setItem("demoBannerVisible", "false");
  };

  if (!isVisible) return null;

  return (
    <Box
      position="relative"
      overflow="hidden"
      transition="all 0.5s ease-in-out"
      maxH="50px"
      boxSizing="border-box"
    >
      <Box
        bgGradient="linear(to-r, blue.400, blue.300)"
        color="white"
        shadow="lg"
      >
        <Flex maxW="7xl" mx="auto" alignItems="center" justifyContent="center">
          <Flex alignItems="center" justifyContent="center" flex={1}>
            <Link
              href="/demo"
              display="flex"
              alignItems="center"
              gap={2}
              _hover={{ textDecoration: "none", color: "whiteAlpha.900" }}
              transition="colors 0.2s"
              group
            >
              <Text
                fontSize={{ base: "sm", md: "md" }}
                fontWeight="medium"
                textDecoration="underline"
                textDecorationOffset="2px"
                _groupHover={{ textDecoration: "underline" }}
              >
                Learn How To Use Bulletscout.com In 30 Seconds
              </Text>
              <ArrowForwardIcon
                h={4}
                w={4}
                animation="pulse 2s infinite"
                keyframes={{
                  pulse: {
                    "0%": { transform: "translateX(0)" },
                    "50%": { transform: "translateX(4px)" },
                    "100%": { transform: "translateX(0)" },
                  },
                }}
              />
            </Link>
          </Flex>
          <IconButton
            aria-label="Close banner"
            icon={<CloseIcon />}
            variant="ghost"
            color="white"
            _hover={{ bg: "whiteAlpha.200" }}
            fontSize={"10px"}
            onClick={handleClose}
          />
        </Flex>
      </Box>
    </Box>
  );
};

export default DemoBanner;
